var path = 'infrastructure/controllers/views/prompt-dialog.html';
var html = "<div class=modal-header> <i class=\"fa fa-check\"></i> </div> <form> <div class=modal-body> <error-box error=isWorking.error></error-box> <h3>{{ options.title }}</h3> <p>{{ options.message }}</p> <input class=\"input-xlarge form-control\" type=text ng-model=options.answer> </div> <div class=modal-footer> <spin active=isWorking.busy></spin> <button type=submit class=\"btn btn-default\" ng-disabled=isWorking.busy ng-class=options.executeButtonClass ng-click=execute()>{{ options.executeButtonText }}</button> <button class=\"btn btn-default\" ng-disabled=isWorking.busy ng-click=close()>Cancel</button> </div> </form> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/views/prompt-dialog.html
// module id = 1015
// module chunks = 1